import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {requestStores} from '../../../ListOfPREditors.brick.jsx';
import {InputAdornment, TextField, Tooltip} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import {getDefaultPaymentTermsLambda} from '../../../../utils/functionSignatures';
import {LAMBDA_NAMES} from '../../../../utils/constants';
import {BrickContext} from 'olympe';

/**
 * @param {PaymentTermsField.propTypes} props
 * @return {JSX.Element}
 */
export function PaymentTermsField(props) {
    const useRequestStore = requestStores.get(props.prTag);

    const [paymentTerms, setPaymentTerms] = useRequestStore((state) => [state.paymentTerms, state.setPaymentTerms]);
    const vendorCode = useRequestStore((state) => state.vendorCode);
    const userIdToCallSAPAPIs = useRequestStore((state) => state.userIdToCallSAPAPIs);
    const purchaseOrganization = useRequestStore((state) => state.purchaseOrganization);

    const [value, setValue] = useState(paymentTerms.value || '');
    const [loading, setLoading] = useState(false);
    const getDefaultPaymentTerms = props.context.get(LAMBDA_NAMES.GET_DEFAULT_PAYMENT_TERMS);

    useEffect(() => {
        // To avoid an error 'Can't perform a React state update on an unmounted component'.
        // Reproduce it -> if we expand the item and then immediately collapse it, getting this error
        let cleanupFunction = false;
        // eslint-disable-next-line require-jsdoc
        function doEffect() {
            getDefaultPaymentTermsLambda(props.context,
                getDefaultPaymentTerms,
                parseInt(vendorCode),
                purchaseOrganization.value,
                userIdToCallSAPAPIs,
                (result) => {
                    if (!cleanupFunction) {
                        const PTs = JSON.parse(result).map((row) => ({
                            label: `${row['Term']} - ${row['NameVAT']}`,
                            value: row['Term'],
                        }));
                        if (PTs.length === 0) {
                            setValue('');
                            setPaymentTerms({label: '', value: ''});
                        } else {
                            setValue(PTs[0].value);
                            setPaymentTerms(PTs[0]);
                        }
                        setLoading(false);
                    }
                },
                () => {
                    if (!cleanupFunction) setLoading(false);
                } );
        }
        setValue('');
        setLoading(true);
        doEffect();

        return () => cleanupFunction = true;
    }, [vendorCode, purchaseOrganization]);
    return (
        <Tooltip title={paymentTerms.label} placement={'top'} arrow>
            <TextField
                style={{width: '30%'}}
                variant={'standard'}
                InputProps={{
                    startAdornment: ( loading &&
                        <InputAdornment position="start">
                            <CircularProgress size={20} />
                        </InputAdornment>
                    ),
                }}
                value={value}
                fullWidth
                disabled />
        </Tooltip>
    );
}

PaymentTermsField.propTypes = {
    prTag: PropTypes.string,
    context: PropTypes.instanceOf(BrickContext).isRequired,
};

PaymentTermsField.infoText = 'Payment terms are fixed, determined by supplier and market. In case you request a different payment term, please add it in the corresponding field so that your Procurement team can assess and amend the Purchase Order accordingly.';
